import {
  Box, FormControl, FormControlLabel, Radio, RadioGroup, Typography,
} from '@mui/material';
import React from 'react';

export default function RadioWBox({
  value,
  onChange,
  options = [],
  disabled = false,
  ariaLabelledBy,
}) {
  return (
    <FormControl component="fieldset" sx={{ width: '100%' }}>
      <RadioGroup
        row
        aria-labelledby={ariaLabelledBy}
        value={value || ''}
        onChange={(e) => onChange(e.target.value)}
        sx={{ gap: 2 }}
      >
        {options.map((option) => {
          const optionDisabled = disabled || option.disabled;
          const optionLabel = option.name || option.label;
          const isSelected = value === option.value;
          return (
            <Box
              key={option.value}
              onClick={() => {
                if (optionDisabled) return;
                onChange(option.value);
              }}
              sx={{
                flex: 1,
                border: '1.5px solid',
                borderColor: isSelected ? 'primary.main' : 'divider',
                borderRadius: 2,
                px: 2,
                py: 1.5,
                cursor: optionDisabled ? 'not-allowed' : 'pointer',
                bgcolor: isSelected ? 'action.selected' : 'transparent',
                opacity: optionDisabled ? 0.6 : 1,
                transition: 'border-color 120ms, background-color 120ms',
                '&:hover': {
                  borderColor: isSelected ? 'primary.main' : 'text.disabled',
                },
              }}
            >
              <FormControlLabel
                value={option.value}
                control={(
                  <Radio
                    size="small"
                    sx={{ p: 0, mr: 1 }}
                    onClick={(e) => e.stopPropagation()}
                    disabled={optionDisabled}
                  />
                )}
                label={(
                  <Typography variant="body2" fontWeight={isSelected ? 500 : 400}>
                    {optionLabel}
                  </Typography>
                )}
                disabled={optionDisabled}
                sx={{ m: 0, width: '100%' }}
              />
            </Box>
          );
        })}
      </RadioGroup>
    </FormControl>
  );
}
